<div class="response-history-area-new p-t-8" [class.regulations-agent-view]="agentId === 'regulations_agent'" *ngIf="!IsNewChat">
  <!-- Lazy loading indicator at the top -->
  <div class="lazy-load-indicator" *ngIf="isLoadingMoreHistory">
    <div class="loading-spinner-small"></div>
    <span class="loading-text-small">Loading more messages...</span>
  </div>
  
  <div class="scrollDiv" *ngFor="let chatdata of ChatQueriesList; let chatCount = index; trackBy: trackByMessageId">
    <div class="card position-relative radius-6">
      <div *ngIf="(chatCount !== (ChatQueriesList.length - 1))">
        <div class="prompt-user-flexbox">
          <div class="prompt-user-text">
            <h6 *ngIf="chatdata.question" class="m-t-0 m-b-0" [innerHtml]="chatdata.question" [id]="'user_question_' + chatCount"></h6>
            <div *ngIf="!chatdata.question" class="m-t-0 m-b-0" aria-hidden="true"></div>
          </div>
        </div>
        <!-- /* istanbul ignore next */ -->
        <div class="card pull-left p-l-0 p-r-0 fullwidth chat-message-not-last-sq class1">
          <div class="response-info-total class1">
            <div class="response-info-icon class1">
              <img [src]="agentIcon" [alt]="agentId">
            </div>
            <div class="response-info-text">
              <div class="response-tabs">
                <div class="tab-content active" [id]="'response-tab-' + chatCount">
                  <div class="row m-b-2">
                    <div class="col-12">
                      <app-shared-response-renderer
                        [answer]="chatdata.answer"
                        [imageVisualization]="chatdata.image_visualization ?? ''"
                        [visualizationData]="chatdata.visualizationData ?? []"
                        [agentId]="agentId"
                        [fusionAppUiUrl]="configdata.FusionAppUIUrl ?? ''"
                        [isLoading]="false"
                        [isStreaming]="false"
                        [errorMessage]="chatdata.errorMessage ?? ''"
                        [filePathsInOrder]="chatdata.file_paths ?? []"
                        (tableDownloaded)="tableDownloaded.emit($event)"
                        (tableDownloadFailed)="tableDownloadFailed.emit()"
                        (filePreviewRequested)="filePreviewRequested.emit($event)"
                        (filePreviewFailed)="filePreviewFailed.emit($event)"
                        (fileDownloadCompleted)="fileDownloadCompleted.emit($event)"
                        (fileDownloadFailed)="fileDownloadFailed.emit($event)">
                      </app-shared-response-renderer>
                    </div>
                  </div>

                  <app-retrieval-mode-history-notice
                    *ngIf="agentId === 'regulations_agent'"
                    [retrievalMode]="chatdata.retrieval_mode"
                    [boxed]="true">
                  </app-retrieval-mode-history-notice>

                  <!-- Metadata (sources) for regulations/RTQ agents -->
                  <div *ngIf="metadataModuleName">
                    <app-chatbot-metadata
                      [chatdata]="chatdata"
                      [configdata]="configdata"
                      [tenantId]="tenantId"
                      [isDocChat]="true"
                      [selected_module_name]="metadataModuleName"
                      [agentId]="agentId"
                      [isloader]="false"
                      [isResponseStreaming]="false"
                      (closeHistory)="onMetadataCloseHistory()"
                      (DisplaySourcePanel)="onMetadataDisplaySourcePanel($event)">
                    </app-chatbot-metadata>
                  </div>


                  <!-- Like / Dislike + Copy / Speaker / Share / Options (below timestamp) - same new popup as last message; disabled when response is loading -->
                  <app-shared-response-feedback
                    *ngIf="chatdata.modified_date"
                    [responseId]="chatdata.pk_chathistoryid ?? null"
                    [isLikeSelected]="chatdata.LikeClassAdded ?? false"
                    [isDislikeSelected]="chatdata.disLikeClassAdded ?? false"
                    [showFeedbackForm]="chatdata.SubmitFeedback ?? false"
                    [additionalComments]="chatdata.AdditionalComments ?? ''"
                    [feedbackOptions]="chatdata.FeedbackOptions ?? []"
                    [commentsOnly]="agentId !== 'regulations_agent'"
                    [isAgent]="true"
                    [disabled]="loaderShow || isResponseStreaming"
                    [showFeedback]="agentOptions.feedback !== false"
                    (likeClick)="onResponseLikeClick(chatdata, $event)"
                    (dislikeClick)="onResponseDislikeClick(chatdata)"
                    (feedbackSubmit)="onResponseFeedbackSubmit(chatdata, $event)"
                    (feedbackCancel)="onResponseFeedbackCancel(chatdata)">
                    <app-shared-response-actions responseActions
                      [chatdata]="chatdata"
                      [renderedAnswerHtml]="chatdata.answer | sanitizeMarkdown"
                      [ChatQueriesList]="ChatQueriesList"
                      [disabled]="loaderShow || isResponseStreaming"
                      [showCopy]="agentOptions.copy !== false"
                      [isAgent]="true"
                      [showAudio]="agentOptions.audio !== false"
                      (listUpdate)="onChatQueriesListEmit($event)">
                    </app-shared-response-actions>
                    <app-shared-response-share responseActions
                      [disabled]="loaderShow || isResponseStreaming"
                      [showShare]="agentOptions.share !== false"
                      [isAgent]="true"
                      (shareClick)="onShareClick(chatdata)">
                    </app-shared-response-share>
                    <app-shared-response-options-menu responseActions
                      [disabled]="loaderShow || isResponseStreaming"
                      [showRegenerate]="agentOptions.regenerate !== false"
                      [isAgent]="true"
                      [timestamp]="formatDateTime(chatdata.modified_date)"
                      (optionsMenuAction)="onResponseOptionsMenuAction(chatdata, $event)">
                    </app-shared-response-options-menu>
                  </app-shared-response-feedback>

                  <!-- Regulations Agent: Related Questions for historical messages (always enabled when not streaming) -->
                  <div class="row" *ngIf="agentId === 'regulations_agent' && chatdata.pills && chatdata.pills.length > 0">
                    <div class="col-12 followup-questions-total">
                      <h6 class="font-subheading1 m-t-20 m-b-15">{{ 'RELATED_QUESTIONS_TITLE_TEXT' | translate }}</h6>
                      <div class="followup-questions-list">
                        <div *ngFor="let item of chatdata.pills; let i = index">
                          <a href="javascript: void(0)"
                            [class.disabled]="loaderShow || isResponseStreaming"
                            (click)="onPillClick(item)"
                            [id]="'follow_up_question_link_' + chatCount + '_' + i">{{ item }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="(chatCount !== (ChatQueriesList.length - 1))">
        </div>
      </div>
    </div>
  </div>

  <div class="lastDiv" [class.animate-last]="animateLastMessage" *ngFor="let chatdata of ChatQueriesList; let chatCount = index; trackBy: trackByMessageId">
    <div *ngIf="(chatCount === (ChatQueriesList.length - 1))">
      <div class="card position-relative radius-6">
        <div class="prompt-user-flexbox">
          <div class="prompt-user-text">
            <h6 *ngIf="chatdata.question" class="font-subheading1 m-t-0 m-b-0 text-line20" [innerHtml]="chatdata.question" id="relative_question_div"></h6>
            <div *ngIf="!chatdata.question" class="font-subheading1 m-t-0 m-b-0 text-line20" aria-hidden="true"></div>
          </div>
        </div>

        <!-- /* istanbul ignore next */ -->
        <div class="card pull-left p-0 p-r-0 fullwidth chat-message-not-last-sq class2">
          <div class="response-info-total class2">
            <div class="response-info-icon">
              <img [src]="agentIcon" [alt]="agentId">
            </div>
            <div class="response-info-text">
              <!-- RIA: thinking loader for first 4 seconds (no dots during this phase) -->
              <div class="ria-thinking-loader-container" *ngIf="showRiaThinkingLoader">
                <app-ria-thinking-loader></app-ria-thinking-loader>
              </div>
              <!-- Dots loader before reasoning (RIA hides during 4s thinking phase) -->
              <div class="loader-before-reasoning" *ngIf="showDotsBeforeReasoning">
                <app-dots-loader></app-dots-loader>
              </div>
              <!-- Engaging Loader for VIA / regulations (not used for RIA) -->
              <div class="engaging-loader-container"
                   [class.regulations-engaging-loader-container]="agentId === 'regulations_agent'"
                   *ngIf="!isRiaAgent && (showEngagingLoader || (chatdata.completedReasoningSteps && chatdata.completedReasoningSteps.length > 0))">
                <app-agent-engaging-loader
                  [isStreaming]="showEngagingLoader ? engagingLoaderIsStreaming : false"
                  [isCompleted]="showEngagingLoader ? engagingLoaderIsCompleted : true"
                  [reasoningSteps]="showEngagingLoader ? engagingLoaderSteps : (chatdata.completedReasoningSteps || [])"
                  [currentAction]="showEngagingLoader ? engagingLoaderCurrentAction : ''">
                </app-agent-engaging-loader>
              </div>

              <!-- Regular response (shown during streaming and after completion) -->
              <div class="response-tabs" *ngIf="!showEngagingLoader || engagingLoaderIsCompleted || chatdata.answer || (chatdata.completedReasoningSteps && chatdata.completedReasoningSteps.length > 0) || loaderShow || isResponseStreaming">
                <div class="tab-content active" id="response-tab-last">
                  <div class="row">
                    <div class="col-12">
                      <app-shared-response-renderer
                        [answer]="chatdata.answer"
                        [imageVisualization]="chatdata.image_visualization ?? ''"
                        [visualizationData]="chatdata.visualizationData ?? []"
                        [agentId]="agentId"
                        [fusionAppUiUrl]="configdata.FusionAppUIUrl ?? ''"
                        [isLoading]="!!loaderShow && !chatdata.answer"
                        [isStreaming]="!!isResponseStreaming"
                        [errorMessage]="chatdata.errorMessage ?? ''"
                        [filePathsInOrder]="chatdata.file_paths ?? []"
                        (tableDownloaded)="tableDownloaded.emit($event)"
                        (tableDownloadFailed)="tableDownloadFailed.emit()"
                        (filePreviewRequested)="filePreviewRequested.emit($event)"
                        (filePreviewFailed)="filePreviewFailed.emit($event)"
                        (fileDownloadCompleted)="fileDownloadCompleted.emit($event)"
                        (fileDownloadFailed)="fileDownloadFailed.emit($event)">
                      </app-shared-response-renderer>
                    </div>
                  </div>

                  <app-retrieval-mode-history-notice
                    *ngIf="agentId === 'regulations_agent' && isConversationSaved"
                    [retrievalMode]="chatdata.retrieval_mode"
                    [boxed]="true">
                  </app-retrieval-mode-history-notice>

                  <!-- Metadata (sources) for regulations agents -->
                  <div *ngIf="metadataModuleName && hasMetadata(chatdata)">
                    <app-chatbot-metadata
                      [chatdata]="chatdata"
                      [configdata]="configdata"
                      [tenantId]="tenantId"
                      [isDocChat]="true"
                      [selected_module_name]="metadataModuleName"
                      [agentId]="agentId"
                      [isloader]="isMetadataLoading"
                      [isResponseStreaming]="isResponseStreaming"
                      (closeHistory)="onMetadataCloseHistory()"
                      (DisplaySourcePanel)="onMetadataDisplaySourcePanel($event)">
                    </app-chatbot-metadata>
                  </div>

                  <!-- Dots loader below thinking/response (regulations stream) or while VIA bubbles load -->
                  <div class="regulations-saving-loader-container" *ngIf="isBubblesLoading || showRegulationsTailLoader">
                    <app-dots-loader></app-dots-loader>
                  </div>

                  <!-- Like / Dislike + Copy / Speaker / Share / Options -->
                  <app-shared-response-feedback
                    *ngIf="chatdata.modified_date && !chatdata.isLoading && !loaderShow && !isResponseStreaming && isConversationSaved"
                    [responseId]="chatdata.pk_chathistoryid ?? null"
                    [isLikeSelected]="chatdata.LikeClassAdded ?? false"
                    [isDislikeSelected]="chatdata.disLikeClassAdded ?? false"
                    [showFeedbackForm]="chatdata.SubmitFeedback ?? false"
                    [additionalComments]="chatdata.AdditionalComments ?? ''"
                    [feedbackOptions]="chatdata.FeedbackOptions ?? []"
                    [commentsOnly]="agentId !== 'regulations_agent'"
                    [isAgent]="true"
                    [disabled]="loaderShow || isResponseStreaming"
                    [showFeedback]="agentOptions.feedback !== false"
                    (likeClick)="onResponseLikeClick(chatdata, $event)"
                    (dislikeClick)="onResponseDislikeClick(chatdata)"
                    (feedbackSubmit)="onResponseFeedbackSubmit(chatdata, $event)"
                    (feedbackCancel)="onResponseFeedbackCancel(chatdata)">
                    <app-shared-response-actions responseActions
                      [chatdata]="chatdata"
                      [renderedAnswerHtml]="chatdata.answer | sanitizeMarkdown"
                      [ChatQueriesList]="ChatQueriesList"
                      [disabled]="loaderShow || isResponseStreaming"
                      [showCopy]="agentOptions.copy !== false"
                      [showAudio]="agentOptions.audio !== false"
                      (listUpdate)="onChatQueriesListEmit($event)">
                    </app-shared-response-actions>
                    <app-shared-response-share responseActions
                      [disabled]="loaderShow || isResponseStreaming"
                      [showShare]="agentOptions.share !== false"
                      (shareClick)="onShareClick(chatdata)">
                    </app-shared-response-share>
                    <app-shared-response-options-menu responseActions
                      [disabled]="loaderShow || isResponseStreaming"
                      [showRegenerate]="agentOptions.regenerate !== false"
                      [isAgent]="true"
                      [timestamp]="formatDateTime(chatdata.modified_date)"
                      (optionsMenuAction)="onResponseOptionsMenuAction(chatdata, $event)">
                    </app-shared-response-options-menu>
                  </app-shared-response-feedback>

                  <!-- Regulations Agent: Related Questions for last message -->
                  <div class="row" *ngIf="agentId === 'regulations_agent' && !loaderShow && !isResponseStreaming && chatdata.pills && chatdata.pills.length > 0">
                    <div class="col-12 followup-questions-total">
                      <h6 class="font-subheading1 m-t-20 m-b-15">{{ 'RELATED_QUESTIONS_TITLE_TEXT' | translate }}</h6>
                      <div class="followup-questions-list">
                        <div *ngFor="let item of chatdata.pills; let i = index">
                          <a href="javascript: void(0)"
                            [class.disabled]="loaderShow || isResponseStreaming || !isConversationSaved"
                            (click)="onPillClick(item)"
                            [id]="'follow_up_question_link_last_' + i">{{ item }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Scroll target element (unique id so getElementById finds agent chat, not chatbot's scrolltobottom) -->
<div id="agent-chat-scrolltobottom" #scrollTarget></div>
